import {
  redirect,
  showClientComponent,
  showAction,
  showProps,
  showPicker,
  showNew,
  openUrl,
  showResult,
  showWizardScheme,
  addQuery,
  deleteQuery,
  editQuery,
  logout,
  customLogout,
  updateProps,
  saveSQ,
  previewQuery,
} from "./handlers";

export const actionHandlers = {
  "redirect.to": redirect,
  "show.clientComponent": showClientComponent,
  "show.action": showAction,
  "open.url": openUrl,
  "show.actionUrl": showAction, // support old dashboard
  "show.props": showProps,
  "show.result": showResult,
  "show.type": showProps,
  "show.picker": showPicker,
  "show.wizard": showWizardScheme,
  "show.new": showNew,
  "update.props": updateProps,
  logout: logout,
  "logout.url": customLogout,

  "savedQuery.save": saveSQ,
  "savedQueries.preview": previewQuery,
  "savedQueries.edit": editQuery,
  "savedQueries.delete": deleteQuery,
  "savedQueries.add": addQuery,
};

export type IActionHandlers = typeof actionHandlers;
export type actionHandlerNames = keyof IActionHandlers;
